import React from 'react'

export const Checkbox = () => {
  return (
    <div><input type="checkbox"/></div>
  )
}
